// Role constants
export const VENUE_ADMIN = 'VENUE_ADMIN'
export const HEAD_CHEF_GM = 'HEAD_CHEF_GM'
export const CHEF = 'CHEF'
export const ORDER_ONLY = 'ORDER_ONLY'
export const KITCHEN_PORTER = 'KITCHEN_PORTER'

export const SYSTEM_ROLE_IDS = [
  VENUE_ADMIN,
  HEAD_CHEF_GM,
  CHEF,
  ORDER_ONLY,
  KITCHEN_PORTER,
]
export const CUSTOM_ROLE_ID_PREFIX = 'custom_'

// Role display names
export const ROLE_DISPLAY_NAMES = {
  [VENUE_ADMIN]: 'Admin',
  [HEAD_CHEF_GM]: 'Head Chef / GM',
  [CHEF]: 'Chef',
  [ORDER_ONLY]: 'Order Only',
  [KITCHEN_PORTER]: 'Kitchen Porter',
}

// Role badge colors
export const ROLE_COLORS = {
  [VENUE_ADMIN]: '#22c55e', // Green
  [HEAD_CHEF_GM]: '#0ea5e9', // Blue
  [CHEF]: '#a855f7', // Purple
  [ORDER_ONLY]: '#fb923c', // Orange
  [KITCHEN_PORTER]: '#64748b',
  PRIMARY_OWNER: '#facc15', // Gold
}

// Role options for dropdowns (in order: Admin, Head Chef/GM, Chef, Order Only)
export const ROLE_OPTIONS = [
  { value: VENUE_ADMIN, label: ROLE_DISPLAY_NAMES[VENUE_ADMIN] },
  { value: HEAD_CHEF_GM, label: ROLE_DISPLAY_NAMES[HEAD_CHEF_GM] },
  { value: CHEF, label: ROLE_DISPLAY_NAMES[CHEF] },
  { value: ORDER_ONLY, label: ROLE_DISPLAY_NAMES[ORDER_ONLY] },
  { value: KITCHEN_PORTER, label: ROLE_DISPLAY_NAMES[KITCHEN_PORTER] },
]

// Helper functions
export const getRoleDisplayName = role => {
  return ROLE_DISPLAY_NAMES[role] || 'Admin'
}

export const CUSTOM_ROLE_COLOR = '#0f766e'

export const getRoleColor = role => {
  if (typeof role === 'string' && role.startsWith(CUSTOM_ROLE_ID_PREFIX)) {
    return CUSTOM_ROLE_COLOR
  }
  return ROLE_COLORS[role] || ROLE_COLORS[VENUE_ADMIN]
}

export const isVenueAdmin = role => {
  return role === VENUE_ADMIN
}

export const isHeadChefGM = role => {
  return role === HEAD_CHEF_GM
}

export const isChef = role => {
  return role === CHEF
}

export const isOrderOnly = role => {
  return role === ORDER_ONLY
}

export const isKitchenPorter = role => {
  return role === KITCHEN_PORTER
}
